import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BusinessService } from '@app/business/business.service';
import { InfoService } from '@app/core/info/info.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cloud-certificate-history',
  templateUrl: './certificate-history.component.html',
  styleUrls: ['./certificate-history.component.scss']
})
export class CertificateHistoryComponent implements OnInit {
  displayedColumns: string[] = ['requestNumber', 'requestDate', 'confirmationDate', 'type', 'requestStatus', 'appliedCRL', 'crlAppliedDate', 'validFrom', 'validTo', 'publicAccess', 'agent', 'agentOffice', 'requestCreatorFullName', 'requestCreatorCompany'];
  certificateHistory = new MatTableDataSource<any>();
  rowData: any;
  loading = false;
  constructor(
    public businessService: BusinessService,
    private translateService: TranslateService,
    public info: InfoService,
  ) { }

  ngOnInit(): void {
    this.rowData = this.businessService.getStoredRowHistory();
    this.getListHistory()
  }

  getListHistory() {
    this.loading = true;
    this.businessService.getManagementHistory(this.rowData.serialNumber).subscribe((res) => {
      this.certificateHistory = res.items
      this.loading = false;
    });
  }
  exportExcel() {
    this.businessService.getManagementHistoryExcelFormat(this.rowData.serialNumber)
      .subscribe((response) => {
        const fileContent = response.body.fileContent;
        const fileName = response.body.filename || 'ManagementHistory.xlsx';
        if (!fileContent) {
          this.info.error('Файлът не е получен коректно.');
          return;
        }
        const byteCharacters = atob(fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        this.info.success(this.translateService.instant('certificates.exportSuccess'));
      });
  }


}

